import { useTheme } from "@nexdel/core/hooks/use-theme";
import { CheckCircle2, XCircle, Info, AlertTriangle, Loader2 } from "lucide-react";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="bottom-right"
      gap={10}
      icons={{
        success: <CheckCircle2 size={18} className="text-primary" />,
        error: <XCircle size={18} className="text-destructive" />,
        warning: <AlertTriangle size={18} className="text-warning" />,
        info: <Info size={18} className="text-blue-500" />,
        loading: <Loader2 size={18} className="text-muted-foreground animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:rounded-lg group-[.toaster]:py-3.5 group-[.toaster]:px-4 group-[.toaster]:gap-3 group-[.toaster]:items-start",
          icon: "group-[.toast]:mt-px group-[.toast]:shrink-0",
          content: "group-[.toast]:gap-0.5",
          title: "group-[.toast]:text-sm group-[.toast]:font-medium group-[.toast]:leading-snug group-[.toast]:tracking-[-0.005em]",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:text-xs group-[.toast]:leading-relaxed",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:text-xs group-[.toast]:h-7 group-[.toast]:px-2.5 group-[.toast]:rounded-md group-[.toast]:font-medium",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:text-xs group-[.toast]:h-7 group-[.toast]:px-2.5 group-[.toast]:rounded-md",
          closeButton: "group-[.toast]:bg-background group-[.toast]:border-border group-[.toast]:text-muted-foreground hover:group-[.toast]:text-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
